'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn$002dResult from "./app.pages.-Documents-Create-Page$-Based-On-Result.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone(newDocKind) {
  this.Yj = null;
  this.Yj = newDocKind;
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone as $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone.prototype = new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn$002dResult.$h_Lapp_pages_DocumentsCreatePage$BasedOnResult();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone as $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone };
$h_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone)) {
    var x = this.Yj;
    var x$2 = x$0.Yj;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Standalone";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yj;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "newDocKind";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ks)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone as $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone };
var $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone, "app.pages.DocumentsCreatePage$BasedOnResult$Standalone", ({
  ks: 1,
  eD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone as $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$Standalone };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On-Result$-Standalone.js.map
